// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"LoadingOverlay_loadingOverlay__Sbt4Q","unactive":"LoadingOverlay_unactive__dH+hY"};